/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: inherit;
  }
  path.none {
    fill: none !important;
  }
`
export default function MessageIco() {
  return (
    <Fragment>
      <svg xmlns="http://www.w3.org/2000/svg" width="80.935" height="63.99" viewBox="0 0 80.935 63.99" css={Color}>
        <g id="그룹_4282" data-name="그룹 4282" transform="translate(-319.395 -100.557)">
          <path className="none" id="교차_5" data-name="교차 5" d="M355.989,135.632l-29.93-26.468a4.408,4.408,0,0,1-.834-.983,9,9,0,0,1,7.724-5.124h52.815a9,9,0,0,1,7.8,5.279,4.511,4.511,0,0,1-.733.828L362.9,135.632a5.348,5.348,0,0,1-6.907,0Z" fill="none" />
          <path id="패스_4349" data-name="패스 4349" d="M388.83,164.52H330.895a11.513,11.513,0,0,1-11.5-11.5V112.836a11.513,11.513,0,0,1,11.5-11.5H388.83a11.513,11.513,0,0,1,11.5,11.5V153.02A11.513,11.513,0,0,1,388.83,164.52Zm-57.935-58.184a6.508,6.508,0,0,0-6.5,6.5V153.02a6.508,6.508,0,0,0,6.5,6.5H388.83a6.507,6.507,0,0,0,6.5-6.5V112.836a6.507,6.507,0,0,0-6.5-6.5Z" fill="#29303a" />
          <path id="패스_4350" data-name="패스 4350" d="M387.88,164.547H331.648a11.553,11.553,0,0,1-7.25-2.574l-.607-.493-.218-.751a3.907,3.907,0,0,1,1.1-3.975L353.516,129.4l4.283,3.488a3.359,3.359,0,0,0,2.044.669,3.591,3.591,0,0,0,2.158-.7l5.066-4.121,28.294,26.723a4.958,4.958,0,0,1,1.6,3.8l-.025.943-.642.692a11.512,11.512,0,0,1-8.4,3.661Zm-59.77-4.161-.016.016Zm59.77-.839h.007a6.49,6.49,0,0,0,3.464-1.006l-24.53-23.165-1.7,1.383a8.269,8.269,0,0,1-5.276,1.794,8.1,8.1,0,0,1-5.165-1.76l-.912-.743-24.353,23.1a6.522,6.522,0,0,0,2.235.4Z" fill="#29303a" />
          <path id="패스_4351" data-name="패스 4351" d="M359.861,138.541a8.5,8.5,0,0,1-5.153-1.731l-.064-.05L322.9,110.952a6.9,6.9,0,0,1-1.365-1.481l-.824-1.207.647-1.31a11.5,11.5,0,0,1,9.822-6.4l.107,0,57.106,0a11.466,11.466,0,0,1,9.916,6.592l.641,1.36-.9,1.2a7.031,7.031,0,0,1-1.2,1.243l-31.735,25.8A8.683,8.683,0,0,1,359.861,138.541Zm-2.1-5.69a3.564,3.564,0,0,0,4.27-.021l30.791-25.038a6.481,6.481,0,0,0-4.591-2.235H331.347a6.5,6.5,0,0,0-4.512,2.148Z" fill="#29303a" />
        </g>
      </svg>

    </Fragment >
  )
}
